import './UserListComponent.css';

function UserListComponent({
  members = [],
  currentUserId,
  onUpdateColor,
  updatingUserId
}) {
  if (members.length === 0) {
    return <p style={{ color: '#888', fontSize: '0.9rem' }}>No members yet.</p>;
  }

  return (
    <div className="user-list">
      {members.map((member) => {
        const user = member.userId || {};
        const userId = user._id || member.userId;
        const canEdit = String(currentUserId) === String(userId);

        return (
          <div key={userId} className="user-list-item">
            <span
              className="user-list-dot"
              style={{ backgroundColor: user.color || '#9ca3af' }}
              title={user.username || 'Member'}
            >
              {(user.username || '?')[0].toUpperCase()}
            </span>
            <div className="user-list-info">
              <span className="user-list-name">{user.username || 'Unknown user'}</span>
              {canEdit &&
                <label className="user-list-color-picker-wrap">
                  <span className="user-list-color-label">Color:</span>
                  <input
                    type="color"
                    className="user-list-color-picker"
                    value={user.color || '#9ca3af'}
                    aria-label="Choose your color"
                    title="Choose your color"
                    disabled={updatingUserId === userId}
                    onChange={(e) => onUpdateColor && onUpdateColor(e.target.value)}
                  />
                </label>
              }
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default UserListComponent;

